import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_DEVICE_URL } from '../../core.global';
import { BasicService } from '../../_base/services/basic.service';

export interface DeviceCurrentPosition {
    device_id: number;
    create_date: string | Date;
    google_lat: number | string;
    google_lng: number | string;
    altitude?: number | string;
    fix_time?: string | Date;
    position_source?: string;
    accuracy_m?: number | string;
}

@Injectable()
export class DeviceService extends BasicService{
    baseUrl:string = '';
    
    constructor(protected http: HttpClient){
        super(http);
        this.baseUrl = API_DEVICE_URL;
    }

    getCurrentPosition(deviceId: number): Observable<DeviceCurrentPosition | null> {
        const params = new HttpParams().set('device_id', String(deviceId));
        return this.http.get<{message: string, item: DeviceCurrentPosition | null}>(
            `${this.baseUrl}/position/current`,
            {params}
        ).pipe(
            map(response => response ? response.item : null)
        );
    }
}
